<template>
	<div class="w-full bg-white shadow-md hover:shadow-lg m-8 p-16">
    	<h4 class="font-serif text-center text-3xl mb-2">
			{{ title }}
		</h4>
    	<h5 class="font-serif text-center text-sm text-red-600 tracking-wide mb-4">
			{{ `Starting at $${price}/month` }}
		</h5>
    
		<p class="font-sans text-center text-sm tracking-wide leading-loose max-w-3/4 mx-auto mb-8">
			{{ description }}
		</p>

		<a :href="link" class="no-underline bg-red-600 center-block font-serif hover:border-gray-700 py-3 rounded w-full max-w-xl text-base text-white text-center">
			Order
		</a>
	</div>
</template>

<script>
export default {
  name: "BundleBlock",
  props: {
    title: String,
    price: Number,
    description: String,
    link: String
  }
};
</script>
